<template>
  <div
    class="task-auto-approved-resubmission-banner"
    data-testid="task-detail-header__auto-approved-resubmission-banner"
  >
    <p
      class="task-auto-approved-resubmission-banner__title"
      data-testid="task-detail-header__auto-approved-resubmission-title"
    >
      {{ title }}
    </p>
    <p
      class="task-auto-approved-resubmission-banner__body"
      data-testid="task-detail-header__auto-approved-resubmission-body"
    >
      {{ body }}
    </p>
  </div>
</template>

<script>
import './TaskAutoApprovedResubmissionBanner.scss';

export default {
  name: 'TaskAutoApprovedResubmissionBanner',

  props: {
    title: {
      type: String,
      required: true,
    },
    body: {
      type: String,
      required: true,
    },
  },
};
</script>
